//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import Vue from 'vue';
import { ACCESS_TOKEN } from "../../store/mutation-types";
import PDFModal from '@comp/PDFView/PDFModal';
export default {
  name: 'FileList',
  mixins: [JeecgListMixin],
  components: {
    PDFModal: PDFModal
  },
  data: function data() {
    return {
      columns: [{
        title: '序号',
        dataIndex: '',
        key: 'rowIndex',
        width: 60,
        align: 'center',
        customRender: function customRender(t, r, index) {
          return parseInt(index) + 1;
        }
      }, {
        title: '文件id',
        dataIndex: 'id',
        align: 'center',
        width: '5%'
      }, {
        title: '文件名称',
        dataIndex: 'fileName',
        align: 'center',
        width: '20%',
        scopedSlots: {
          customRender: 'fileName'
        }
      }, {
        title: '文件后缀',
        dataIndex: 'suffixName',
        align: 'center',
        width: '8%'
      }, {
        title: '文件路径',
        dataIndex: 'filePath',
        align: 'center',
        width: '20%'
      }, {
        title: '文件大小',
        dataIndex: 'fileSize',
        align: 'center',
        width: '8%',
        scopedSlots: {
          customRender: 'fileSize'
        }
      }, {
        title: '文件来源',
        dataIndex: 'fileSrc',
        align: 'center',
        width: '8%'
      }, {
        title: '文件来源Id',
        dataIndex: 'srcId',
        align: 'center',
        width: '8%'
      }, {
        title: '上传人',
        align: 'center',
        dataIndex: 'createBy_userName',
        width: '8%'
      }, {
        title: '上传时间',
        align: 'center',
        dataIndex: 'createTime',
        colName: 'create_time',
        width: '8%',
        sorter: true
      }, {
        title: '操作',
        width: '8%',
        align: 'center',
        scopedSlots: {
          customRender: 'operation3'
        }
      }],
      url: {
        list: '/sys/common/file'
      },
      isDrag: false,
      headers: {},
      //设置上传的请求头部，IE10 以上有效
      onPicDrag: false,
      uploading: false,
      fileUploadUrl: window._CONFIG['domianURL'] + '/sys/common/file/upload',
      //使用专门的接口上传文件
      fileReplaceUrl: window._CONFIG['domianURL'] + '/sys/common/file/replace' //使用专门的接口上传文件

    };
  },
  created: function created() {
    var token = Vue.ls.get(ACCESS_TOKEN);
    this.headers = {
      'X-Access-Token': token
    }; //this.loadUploadFiles()
  },
  computed: {
    /**
     * 上传的地址
     */
    uploadAction: function uploadAction() {
      return this.fileUploadUrl;
    },
    replaceAction: function replaceAction() {
      return this.fileReplaceUrl;
    }
  },
  methods: {
    openPDF: function openPDF(item) {
      this.$refs.pdfview.showPDF(item.id + '-' + item.fileName, window._CONFIG['domianURL'] + '/sys/common/file/view/' + item.id, 'online');
    },

    /* 文件下载 */
    downUploadFile: function downUploadFile(text) {
      if (!text) {
        this.$message_custom('未知的文件', 'warning');
        return;
      }

      window.open(window._CONFIG['domianURL'] + '/sys/common/file/download/' + text);
    },
    // 主要成分表格相关的操作函数
    handleFileUpload: function handleFileUpload(info) {
      if (info.file.status === 'done') {
        this.uploading = false;
        var response = info.file.response;

        if (!response.success) {
          this.$message_custom('文件上传失败,请重试!', 'error');
        } else {
          this.$message_custom('替换成功！', 'success');
          this.loadData();
        }
      }

      if (info.file.status === 'error') {
        this.uploading = false;
        this.$message_custom('文件上传失败,无服务未响应!', 'error');
      }
    }
  },
  filters: {
    numFilter: function numFilter(value) {
      var realVal = '';

      if (!isNaN(value) && value !== '') {
        // 截取当前数据到小数点后两位
        realVal = parseFloat(value).toFixed(2);
      } else {
        realVal = '--';
      }

      return realVal;
    }
  }
};